import React from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ConsentBanner({ onAccept, onReject }) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: "fixed",
        left: 12,
        right: 12,
        bottom: 12,
        zIndex: 2500,
      }}
    >
      <Alert
        severity="info"
        sx={{
          boxShadow: 6,
          borderRadius: 2,
          alignItems: "center",
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1.5}
          alignItems={{ xs: "flex-start", sm: "center" }}
        >
          <Typography variant="body2">
            {t("consent_banner.message")}
          </Typography>

          <Stack direction="row" spacing={1}>
            <Button size="small" variant="contained" onClick={onAccept}>
              {t("consent_banner.accept")}
            </Button>

            <Button
              size="small"
              variant="outlined"
              color="inherit"
              onClick={onReject}
            >
              {t("consent_banner.reject")}
            </Button>
          </Stack>
        </Stack>
      </Alert>
    </Box>
  );
}